<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="otherTrafficCompetition" :value="1" :disabled="disabled">
                    Otros
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        otherTrafficCompetition: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localOtherTrafficCompetition: this.otherTrafficCompetition,
        }
    },
    watch: {
        otherTrafficCompetition(newVal) {
            this.localOtherTrafficCompetition = newVal
            this.$emit('update', { other_traffic_competition: this.localOtherTrafficCompetition })
        },
    },
}
</script>
